import { FC } from 'react'
import cx from 'classnames'
import { useTranslation } from 'next-i18next'

import { XIcon, CheckIcon } from 'icons'

const PasswordValidationBox: FC<{ className?: string }> = ({
  children,
  className,
}) => {
  return <ul className={cx(className, 'text-teal-4 body-sm')}>{children}</ul>
}

const PasswordValidationMessage: FC<{ msg: string; isValid: boolean }> = ({
  msg,
  isValid,
}) => {
  const { t } = useTranslation('auth')

  if (!isValid) {
    return (
      <li className="flex">
        <span className="sr-only">{t('password-validation.fails')}</span>
        <XIcon
          aria-hidden="true"
          className="mt-4 mr-6 shrink-0 stroke-teal-4 rect-12"
        />{' '}
        {msg}
      </li>
    )
  }

  return (
    <li className="flex text-success-1">
      <span className="sr-only">{t('password-validation.passes')}</span>
      <CheckIcon
        aria-hidden="true"
        className="mt-4 mr-6 shrink-0 stroke-success-1 rect-12"
      />{' '}
      {msg}
    </li>
  )
}

export { PasswordValidationBox, PasswordValidationMessage }
